import { createContext } from 'react'

export const RedirectSignupContext = createContext({
    redirectState: null,
    setRedirectState: () => {},
})

export default RedirectSignupContext
